module.exports = __webpack_public_path__ + "static/img/man3.2456914.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/HumanPic/man3.png
// module id = yUDq
// module chunks = 2